import axios from 'axios';
import { store } from '../store.js'
import router from '../router'

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.data.error.statusCode === 401) {
    store.resetLoginInfo();
    router.push('/login');
  }
  return Promise.reject(error)
})

export default {
  get(url, auth) {
    let config;
    if (auth) {
      config = {
        headers: {
          'Authorization': store.getToken()
        }
      }
    }

    let serverTarget = process.env.VUE_APP_API_BASE_URI;
    return axios.get(serverTarget + url, config);
  },

  post(url, auth, data) {
    let config;

    if (auth) {
      config = {
        headers: {
          'Authorization': store.getToken()
        }
      }
    }
    let serverTarget = process.env.VUE_APP_API_BASE_URI;
    return axios.post(serverTarget + url, data, config);
  },

  put(url, auth, data) {
    let config;

    if (auth) {
      config = {
        headers: {
          'Authorization': store.getToken()
        }
      }
    }
    let serverTarget = process.env.VUE_APP_API_BASE_URI;
    return axios.put(serverTarget + url, data, config);
  },

  delete(url, auth, data) {
    let bodyData = {
      data: data
    };

    if (auth) {
      bodyData.headers = {
          'Authorization': store.getToken()
      }
    }
    let serverTarget = process.env.VUE_APP_API_BASE_URI;
    return axios.delete(serverTarget + url, bodyData);
  },

  async getOrdersConfirmation() {
    const response = await this.get('/Payments/admin/getPaymentsAwaitingConfirmation', true);

    return response.data;
  },
  async getOrdersDispatch() {
    const response = await this.get('/Payments/admin/getPaymentsAwaitingDispatch', true);

    return response.data;
  },
  async getOrdersAwaitingPayment() {
    const response = await this.get('/Payments/admin/getPaymentsWithPendingFlag', true);

    return response.data;
  },
  async confirmOrder(cartId, address) {
    let postbody = {
      cartId: cartId,
      address: address
    }
    const response = await this.post('/Payments/admin/sendOrderConfirmationEmail', true, postbody);

    return response.data;
  },
  async cancelOrderAndNotify(cartId) {
    const response = await this.post('/Payments/admin/sendCartAbandonedEmail?cartId=' + cartId, true);

    return response.data;
  },
  async cancelOrderSilent(cartId) {
    const response = await this.post('/Payments/admin/cancelCart?cartId=' + cartId, true);

    return response.data;
  },
  async resendSubmitOrder(cartId) {
    const response = await this.post('/Payments/resendSubmitOrder?cartId=' + cartId, true);

    return response.data;
  },
  async getCart(cartId) {
    const response = await this.get('/Cartitems/getCart?cartId=' + cartId, true);

    return response.data;
  },
  async markOrderAsDispatched(cartId, trackingNumber) {
    if (trackingNumber) {
      const response = await this.post('/Payments/admin/sendOrderDispatchEmail?cartId=' + cartId + '&trackingNumber=' + trackingNumber, true);
      return response.data;
    } else {
      const response = await this.post('/Payments/admin/sendOrderDispatchEmail?cartId=' + cartId, true);
      return response.data;
    }
  },
  async tryLogin(username, password) {
    const loginData = { username: username, password: password }
    const response = await this.post('/Users/login', false, loginData);
    return response;
  },
  async getMessage(messageType) {
    const response = await this.get('/Messages/getMessage?type=' + messageType, false);
    return response.data;
  },
  async postMessage(messageType, message) {
    const response = await this.post('/Messages/admin/setMessage?type=' + messageType + '&message=' + message, true);
    return response;
  },
  async getCartAddress(cartId) {
    const response = await this.get('/Payments/admin/getAddressLabelForCart?cartId=' + cartId, true);
    return response.data;
  },
  async getPaymentsByName(searchTerm) {
    const response = await this.get('/Payments/admin/getPaymentsByName?name=' + searchTerm, true);
    return response.data;
  },
  async getPendingPayments() {
    const response = await this.get('/Payments/admin/getPaymentsWithPendingFlag', true);
    return response.data;
  },
  async getRecentPayments() {
    const response = await this.get('/Payments/admin/getRecentPayments', true);
    return response.data;
  },
  async getEbayItems() {
    const response = await this.get('/Ebayitems/admin/getAllItems', true);
    return response.data;
  },
  async putEbayItem(id, ebayItem, ebayModel, itemList) {
    let putbody = {
      id: id,
      ebayItem: ebayItem,
      ebayModel: ebayModel,
      itemList: itemList
    };
    const response = await this.put('/Ebayitems/admin/putItem', true, putbody);
    return response.data;
  },
  async postEbayItem(ebayItem, ebayModel, itemList) {
    let postbody = {
      ebayItem: ebayItem,
      ebayModel: ebayModel,
      itemList: itemList
    };
    const response = await this.post('/Ebayitems/admin/addItem', true, postbody);
    return response.data;
  },
  async deleteEbayItem(id) {
    let postbody = {}
    const response = await this.delete('/Ebayitems/admin/deleteItem?itemId='+id, true, postbody);
    return response;
  },
  async getCartId() {
    const response = await this.get('/Cartitems/getCartId', false);
    return response.data;
  },
  async postEbayOrder(postbody) {
    const response = await this.post('/Payments/admin/addEbayOrder', true, postbody);
    return response;
  },
  async getInvitationByCartId(cartId) {
    const response = await this.get('/Payments/admin/getInvitationByCartId?cartId=' + cartId, true);
    return response.data;
  },
  async getPaymentForCart(cartId) {
    const response = await this.get('/Payments/admin/getPaymentForCart?cartId=' + cartId, true);
    return response.data;
  },
  async postUpdatepaymentStatus(cartId, newStatus) {
    const response = await this.post('/Payments/admin/updateIsPaid?cartId=' + cartId + '&paymentStatus=' + newStatus, true);
    return response;
  },
  async getAllItems() {
    const response = await this.get('/Items/admin/getAllItems', true);
    return response.data;
  },
  async putItem(id, description, item, type, priceUsd, priceEur, packaging, weight) {
    let putbody = {
      id: id,
      item: item,
      type: type,
      description: description,
      active: true,
      itemPrices: [
        { currency: 'usd', price: priceUsd },
        { currency: 'eur', price: priceEur },
      ],
      packaging: packaging,
      weight: weight
    };
    const response = await this.put('/Items/admin/putItem', true, putbody);
    return response.data;
  },
  async postItem(description, item, type, priceUsd, priceEur, packaging, weight) {
    let postbody = {
      item: item,
      type: type,
      description: description,
      active: true,
      itemPrices: [
        { currency: 'usd', price: priceUsd },
        { currency: 'eur', price: priceEur },
      ],
      packaging: packaging,
      weight: weight
    };
    const response = await this.post('/Items/admin/addItem', true, postbody);
    return response.data;
  },
  async postAddItemToCartAdmin(cartId, item, quantity, price, currency) {
    const response = await this.post('/Cartitems/admin/addItemToCart?cartId=' + cartId + '&itemId=' + item + '&quantity=' + quantity + '&price=' + price + '&currency=' + currency, true);
    return response;
  },
  async deleteItemFromCartAdmin(cartId,itemId) {
    let postbody = {
      cartId: cartId,
      itemId: itemId
    }
    const response = await this.delete('/Cartitems/admin/deleteItemFromCart', true, postbody);
    return response;
  },
  async deleteCartAdmin(cartId) {
    let postbody = {
    }
    const response = await this.delete('/Cartitems/admin/deleteCart?cartId=' + cartId, true, postbody);
    return response;
  },
  async postRecalculatePaymentTotal(cartId) {
    const response = await this.post('/Payments/admin/recalculatePaymentTotal?cartId=' + cartId, true);
    return response;
  },
  async postUpdateEmailByCartAndKey(cartId, key, email) {
    const response = await this.post('/Payments/admin/updateEmailByCartAndKey?cartId=' + cartId + '&key=' + key + '&email=' + email, false);
    return response;
  },
  async postAddPaymentNotes(cartId, notes) {
    let postbody = {
      cartId: cartId,
      notes: notes
    }
    const response = await this.post('/Payments/admin/addPaymentNotes', true, postbody);
    return response;
  },
  async postAddPaymentNotesToCustomer(cartId, notes) {
    let postbody = {
      cartId: cartId,
      notes: notes
    }
    const response = await this.post('/Payments/admin/addPaymentNotesToCustomer', true, postbody);
    return response;
  },
  async getAllPayments() {
    const response = await this.get('/Payments/admin/getAllPayments', true);
    return response.data;
  },
  async getAllPaymentsAfter(cutoffDate) {
    const response = await this.get('/Payments/admin/getAllPaymentsAfter?cutoffDate='+cutoffDate, true);
    return response.data;
  },
  async postUpdatePaymentInformation(updateBody) {
    const response = await this.post('/Payments/admin/updatePaymentInformation', true, updateBody);
    return response;
  },
  async deletePayment(paymentId) {
    const response = await this.delete('/Payments/admin/deletePayment?paymentId='+paymentId, true);
    return response.data;
  },
  async postCreatePaymentNoNotification(cartId, email, paymentType) {
    const response = await this.post('/Payments/admin/createPaymentNoNotification?cartId=' + cartId + '&email=' + email + '&paymentType=' + paymentType, true);
    return response;
  },
  async deleteItem(itemId) {
    const response = await this.delete('/Items/admin/deleteItem?itemId='+itemId, true);
    return response;
  },
  async getAllPostalrates() {
    const response = await this.get('/PostalRates/admin/getAllRates', true);
    return response.data;
  },
  async putPostalrate(id, description, packaging, weightUntil, price) {
    let putbody = {
      id: id,
      description: description,
      packaging: packaging,
      weightUntil: weightUntil,
      price: price,
    };
    const response = await this.put('/PostalRates/admin/putRate', true, putbody);
    return response.data;
  },
  async postPostalrate(description, packaging, weightUntil, price) {
    let postbody = {
      description: description,
      packaging: packaging,
      weightUntil: weightUntil,
      price: price,
    };
    const response = await this.post('/PostalRates/admin/addRate', true, postbody);
    return response.data;
  },
  async deletePostalrate(postalrateId) {
    const response = await this.delete('/PostalRates/admin/deleteRate?postalRateId='+postalrateId, true);
    return response;
  },
};
